import React from 'react';
import { translate } from '../../services/i18n';

export const PageMaintenceIndicator = () => {
  return (
    <div className='page-in-maintence-indicator-box'>
      <h1>{translate('PRODUCTS.MAINTENCE_PAGE')}</h1>
    </div>
  );
};